module.exports = __webpack_public_path__ + "img/work.6a0c61a6.svg";